import { useId } from 'react';
import styles from './SActionButton.module.css';

export default function SActionButton({ fullWidth = true, ...props }: SActionItem) {
    const _componentId = useId();

    return (
        <div
            id={props.id ?? `s-action-${_componentId}`}
            className={`${styles.SActionButton} ${fullWidth ? styles.FullWidth : ''} ${props.active ? styles.Active : ''} ${props.disabled ? styles.Disabled : ''}`}
            onClick={props.disabled ? undefined : props.onAction}
        >
            <s-stack direction="block" gap="none">
                <s-stack direction="inline" gap="none" alignItems="center">
                    {props.icon && (
                        <s-box paddingInlineEnd="small-300">
                            <s-icon type={props.icon} />
                        </s-box>
                    )}
                    <s-text>{props.content}</s-text>
                </s-stack>
                {props.helpText && <small style={{ color: '#616161', fontSize: '11px' }}>{props.helpText}</small>}
            </s-stack>
        </div>
    );
}

export interface SActionItem {
    id?: string;
    content: string;
    onAction: () => void;
    icon?: HTMLElementTagNameMap['s-icon']['type'];
    disabled?: boolean;
    helpText?: string;
    fullWidth?: boolean;
    active?: boolean;
}
